import React from "react";
import { Box, Divider, List, ListItem, ListItemText, Typography } from "@mui/material";

const ChatSidebarContent = ({ serverName, playerCount, playerNames }) => (
    <Box sx={{ bgcolor: "background.paper", height: "100%", display: "flex", flexDirection: "column" }}>
        <Typography variant="subtitle1" sx={{ p: 2, borderBottom: 1, borderColor: "divider", fontWeight: 'medium' }}>
            Сервер
        </Typography>
        <List sx={{ py: 0 }}>
            <ListItem sx={{ py: 1.5 }}>
                <ListItemText primary={serverName} primaryTypographyProps={{ variant: 'body2', noWrap: true }} />
            </ListItem>
        </List>
        <Divider />
        <Typography variant="subtitle1" sx={{ p: 2, borderBottom: 1, borderColor: "divider", fontWeight: 'medium' }}>
            Участники ({playerCount})
        </Typography>
        <List sx={{ flexGrow: 1, overflowY: "auto", py: 0 }}>
            {playerNames.length > 0 ? (
                playerNames.map((playerName) => (
                    <ListItem key={playerName} sx={{ py: 0.75, '&:hover': { bgcolor: 'action.hover' } }}>
                        <ListItemText primary={playerName} primaryTypographyProps={{ variant: 'body2' }} />
                    </ListItem>
                ))
            ) : (
                <ListItem sx={{ py: 1.5 }}>
                    <ListItemText primary="Нет участников" primaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }} />
                </ListItem>
            )}
        </List>
    </Box>
);

export default ChatSidebarContent;
